import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Indicate on which account you wish to receive your reimbursements.',
    ibanProfileCallout:
      'These bank details will be automatically saved for future requests. You can modify it at any time from your personal space.',
    submit: 'Continue',
    title: 'Register your bank details',
  },
  fr: {
    description:
      'Indiquez sur quel compte vous souhaitez recevoir vos remboursements.',
    ibanProfileCallout:
      'Ce RIB sera automatiquement enregistré pour les prochaines demandes. Vous pouvez le modifier à tout moment depuis votre espace personnel.',
    submit: 'Continuer',
    title: 'Enregistrez vos informations bancaires',
  },
} as const);

export default locales;
